import {
  Brain,
  Compose,
  Form,
  Functions,
  Headset,
  LibraryMusic,
  Metronome,
  MusicNote,
  Transform,
} from '@tunasong/icons'
import type { FC } from 'react'

/**
 * Registration metadata for the sidebar "Music Theory" group.
 *
 * This array is the single source of truth for the group's membership AND
 * order — authored top-to-bottom in Bowie's pedagogical order (Overview first,
 * then the prerequisite chain, then the three capstones). Reorder here, not in
 * the sidebar component.
 *
 * The flat tool rows (Mixer, Tuner, Keyboard chords, Guitar Chords, Guitar
 * Patterns) are intentionally NOT in this list — they stay ungrouped.
 */
export interface MusicTheoryTool {
  /** Sidebar label. "Overview" is the hub page relabeled for this context only. */
  label: string
  /** App route the row navigates to. */
  route: string
  /** Icon component from @tunasong/icons. */
  Icon: FC
}

export const musicTheoryTools: MusicTheoryTool[] = [
  { label: 'Overview', route: '/app/theory', Icon: MusicNote },
  { label: 'Circle of Fifths', route: '/app/circle', Icon: MusicNote },
  { label: 'Function Quiz', route: '/app/quiz', Icon: Brain },
  { label: 'Cadence Lab', route: '/app/cadences', Icon: Functions },
  { label: 'Mode Lab', route: '/app/modes', Icon: LibraryMusic },
  { label: 'Reharm Lab', route: '/app/reharm', Icon: Transform },
  { label: 'Voice-Leading Lab', route: '/app/voice-leading', Icon: MusicNote },
  { label: 'Modulation Lab', route: '/app/modulate', Icon: MusicNote },
  { label: 'Form Visualizer', route: '/app/form', Icon: Form },
  { label: 'Melody Writer', route: '/app/melody', Icon: Compose },
  { label: 'Ear Training', route: '/app/ear-training', Icon: Headset },
  { label: 'Pitch Training', route: '/app/pitch-training', Icon: Headset },
  { label: 'Melody Trainer', route: '/app/melody-trainer', Icon: Headset },
  { label: 'Rhythm Trainer', route: '/app/rhythm', Icon: Metronome },
]
